/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Team_Linkedin_LabelInputs */



/**
* | output |
* | --- |
* | "{name} on LinkedIn" |
*
* @param {Team_Linkedin_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_linkedin_label = /** @type {((inputs: Team_Linkedin_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Linkedin_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`${i?.name} 的 LinkedIn 主页`)
	return /** @type {LocalizedString} */ (`${i?.name} on LinkedIn`)
});